import {Observable} from 'rxjs';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {ApiAccessAudit, ApiAccessConsumer, ApiAccessKey} from '../entity/profile-api-access';

// Customer "API access" tab: the customer's Payments API (eapi) consumers
@Injectable()
export class CustomerProfileApiAccessService {

    constructor(private _http: Http) {
    }

    getConsumers(profileId: number): Observable<ApiAccessConsumer[]> {
        return this._http.get(`/api/backoffice/customers/${profileId}/api-access`)
            .map(response => response.json());
    }

    // The response carries the API key: show it once and do not keep it
    create(profileId: number, name: string, authorities: number[]): Observable<ApiAccessKey> {
        return this._http.post(`/api/backoffice/customers/${profileId}/api-access`, {name: name, authorities: authorities})
            .map(response => response.json());
    }

    // The response carries the new API key: show it once and do not keep it
    rotateKey(profileId: number, consumerId: number): Observable<ApiAccessKey> {
        return this._http.post(`/api/backoffice/customers/${profileId}/api-access/${consumerId}/rotate-key`, {})
            .map(response => response.json());
    }

    updatePermissions(profileId: number, consumerId: number, authorities: number[]): Observable<ApiAccessConsumer> {
        return this._http.put(`/api/backoffice/customers/${profileId}/api-access/${consumerId}/permissions`,
            {authorities: authorities})
            .map(response => response.json());
    }

    block(profileId: number, consumerId: number): Observable<ApiAccessConsumer> {
        return this._http.post(`/api/backoffice/customers/${profileId}/api-access/${consumerId}/block`, {})
            .map(response => response.json());
    }

    unblock(profileId: number, consumerId: number): Observable<ApiAccessConsumer> {
        return this._http.post(`/api/backoffice/customers/${profileId}/api-access/${consumerId}/unblock`, {})
            .map(response => response.json());
    }

    getAudit(profileId: number, consumerId: number): Observable<ApiAccessAudit[]> {
        return this._http.get(`/api/backoffice/customers/${profileId}/api-access/${consumerId}/audit`)
            .map(response => response.json());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/service/customer-profile-api-access.service.ts